/**
 * @name soapTypes
 * @see apps/application/models/orm/TblSoapPeer.php
 */

const SOAP_TYPE = {
    BASIC: 0,
    SIMPLE: 1,
    STANDARD: 2,
    CUSTOM: 8
};

export default {
    SOAP_TYPE
};
